import React, { createContext } from "react";

const ProfileContext = createContext({
  userProfile: {},
  userProfilePic: "",
  companyProfile: {},
  companyProfilePic: "",
  visitorStatus: "",
  currentTotalVisitCount: "",
  visitorsNotCheckedOut: "",
  resendTimer: false,
  visitorEvents: false,

  setUserProfile: () => {},
  setUserProfilePic: () => {},
  setCompanyProfile: () => {},
  setCompanyProfilePic: () => {},
  setVisitorStatus: () => {},
  setCurrentTotalVisitCount: () => {},
  setVisitorsNotCheckedOut: () => {},
  setResendTimer: () => {},
  setVisitorEvents: () => {},
});

export default ProfileContext;
